import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationPage as ConfirmationPagePk } from 'omni-package-react-core';
import { P } from 'ia-react-core';
import Constants from '../../Constants';

export interface ConsentConfirmationPageProps { }

const ConsentConfirmationPage: FC<ConsentConfirmationPageProps> = () => {
  const { t } = useTranslation('ConsentConfirmationPage');

  return (
    <ConfirmationPagePk
      title={t('title')}
      redirect={Constants.ProfilePath}
    >
      <P>{t('information')}</P>
    </ConfirmationPagePk>
  );
};
export default ConsentConfirmationPage;
